theme.footerSection = (function() {
  function footer() {
    let accordion = true;

    const slideUp = (element, duration = 300) => {
      element.style.transitionProperty = 'height, margin, padding';
      element.style.transitionDuration = duration + 'ms';
      element.style.boxSizing = 'border-box';
      element.style.height = element.offsetHeight + 'px';
      element.offsetHeight; // force reflow
      element.style.overflow = 'hidden';
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;
      element.style.marginTop = 0;
      element.style.marginBottom = 0;
      window.setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
      }, duration);
    };

    const slideDown = (element, duration = 300) => {
      element.style.removeProperty('display');
      let display = window.getComputedStyle(element).display;
      if (display === 'none') display = 'block';
      element.style.display = display;
      let height = element.offsetHeight;
      element.style.overflow = 'hidden';
      element.style.height = 0;
      element.style.paddingTop = 0;
      element.style.paddingBottom = 0;
      element.style.marginTop = 0;
      element.style.marginBottom = 0;
      element.offsetHeight; // force reflow
      element.style.boxSizing = 'border-box';
      element.style.transitionProperty = 'height, margin, padding';
      element.style.transitionDuration = duration + 'ms';
      element.style.height = height + 'px';
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      window.setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
      }, duration);
    };

    const getSiblings = (element) => {
      return Array.prototype.filter.call(element.parentNode.children, function(child) {
        return child !== element;
      });
    };

    const footerWidgetAccordion = function() {
      accordion = false;
      document.querySelectorAll(".footer__block--toggle").forEach(function(item) {
        item.addEventListener('click', function() {
          const footerWidget = this.closest('.footer__block'),
                footerWidgetInner = footerWidget.querySelector('.footer__block_inner');
          if (footerWidget.classList.contains('active')) {
            footerWidget.classList.remove('active');
            slideUp(footerWidgetInner);
          } else {
            footerWidget.classList.add('active');
            slideDown(footerWidgetInner);
            getSiblings(footerWidget.parentElement).forEach(function(sibling) {
              const siblingWidget = sibling.querySelector('.footer__block'),
                    siblingWidgetInner = sibling.querySelector('.footer__block_inner');
              siblingWidget.classList.remove('active');
              slideUp(siblingWidgetInner);
            });
          }
        });
      });
    };

    window.addEventListener('load', function() {
      if (accordion) {
        footerWidgetAccordion();
      }
    });

    window.addEventListener('resize', function() {
      document.querySelectorAll('.footer__block').forEach(function(item) {
        if (window.outerWidth >= 768) {
          item.classList.remove('active');
          item.querySelector('.footer__block_inner').style.display = '';
        }
      });
      if (accordion) {
        footerWidgetAccordion();
      }
    });
  }

  return footer;
})();
